import React, { useState } from "react";
import { useAuth } from "../auth/AuthContext";

export const ChangePasswordPage: React.FC = () => {
  const { client } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setMessage(null);
    if (newPassword !== confirmPassword) {
      setError("As senhas nao conferem.");
      return;
    }
    const response = await client.post("/auth/change-password", {
      currentPassword,
      newPassword,
    });
    if (!response.ok) {
      setError("Falha ao alterar senha.");
      return;
    }
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setMessage("Senha alterada com sucesso.");
  };

  return (
    <div className="container py-4">
      <h1 className="mb-3">Alterar senha</h1>
      <div className="card shadow-sm">
        <div className="card-body">
          {message && <div className="alert alert-success">{message}</div>}
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit} className="d-grid gap-2">
            <div>
              <label className="form-label">Senha atual</label>
              <input
                className="form-control"
                type="password"
                value={currentPassword}
                onChange={(event) => setCurrentPassword(event.target.value)}
                required
              />
            </div>
            <div>
              <label className="form-label">Nova senha</label>
              <input
                className="form-control"
                type="password"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                required
              />
            </div>
            <div>
              <label className="form-label">Confirmar nova senha</label>
              <input
                className="form-control"
                type="password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                required
              />
            </div>
            <button className="btn btn-primary" type="submit">
              Atualizar senha
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
